import styled from "styled-components";

import { Link, VmSplitLogo } from "@vinomofo/components";

export interface FooterLogoProps {
  height?: string;
}

const LogoLink = styled(Link)<FooterLogoProps>`
  height: ${({ height }) => height};
  display: block;
  margin-right: 16px;

  svg {
    width: auto;
    height: inherit;
    vertical-align: middle;
  }
`;

export const FooterLogo = ({ height }: FooterLogoProps): JSX.Element => {
  return (
    <LogoLink href="/" height={height}>
      <VmSplitLogo vinoColor="#77B204" mofoColor="#77B204" />
    </LogoLink>
  );
};

FooterLogo.defaultProps = {
  height: "24px",
};
